import { render, staticRenderFns } from "./drugSpecExample.vue?vue&type=template&id=6f68732e&scoped=true"
import script from "./drugSpecExample.vue?vue&type=script&lang=js"
export * from "./drugSpecExample.vue?vue&type=script&lang=js"
import style0 from "./drugSpecExample.vue?vue&type=style&index=0&id=6f68732e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f68732e",
  null
  
)

export default component.exports